{
  "accountTitle": "账户名称",
  "accountWalletName": "账户/钱包名称",
  "approvedBalance": "已批准余额",
  "approvedRewards": "已批准奖励",
  "availableBalance": "可用余额",
  "balance": "余额",
  "bank": "银行",
  "bnbWallet": "BNB 钱包",
  "buyBnbUsdt": "购买 BNB / USDT",
  "buyBnbUsdtText": "直接购买 BNB 或 USDT 以充值您的钱包。",
  "buyCryptoSubtitle": "安全购买加密货币，为您的 EXALT 钱包充值。",
  "buyExaltCoin": "购买 EXALT 币",
  "buyExaltOnPancake": "在 PancakeSwap 上购买 EXALT",
  "connectedWallet": "已连接钱包",
  "copied": "已复制",
  "copyAddress": "复制地址",
  "copyContract": "复制合约",
  "copyExaltContract": "复制 EXALT 合约地址",
  "copyFailed": "复制失败",
  "copyIban": "复制IBAN",
  "copyNumber": "复制号码",
  "deposit": "充值",
  "depositAddress": "充值地址",
  "depositFailed": "充值失败。",
  "depositRequest": "充值请求",
  "depositRequiredFields": "姓名、账户/钱包及金额为必填项。",
  "depositSubmittedSuccessfully": "充值请求提交成功。",
  "estimatedExchangeWalletValue": "交易所钱包预估价值",
  "exaltContractCopied": "EXALT 合约地址已复制。",
  "exaltWallet": "EXALT 钱包",
  "fakeSupportReminder": "谨防虚假客服人员。Exalt Exchange 工作人员绝不会索要您的密码或私钥。",
  "loadingWallet": "钱包加载中...",
  "lockedBalance": "锁定余额",
  "pendingRewards": "待处理奖励",
  "readyTradingWithdrawal": "可用于交易或提现。",
  "refreshBalance": "刷新余额",
  "securityAdminApproval": "钱包入账前需经管理员审批。",
  "securityBackendApproval": "充值与提现均受后台审批保护。",
  "securityLicensedGateways": "款项通过持牌支付网关处理。",
  "securityNoAutoRelease": "未经验证不会自动发放代币。",
  "securityReminder": "安全提醒",
  "securitySystem": "安全体系",
  "securityWalletVerification": "钱包所有权验证可保护您的资产。",
  "sellSwapBack": "卖出/换回",
  "sellSwapBackText": "随时可将您的 EXALT 换回 BNB 或 USDT。",
  "serverError": "服务器错误。",
  "sessionExpired": "会话已过期，请重新登录。",
  "step1": "第一步",
  "step2": "第二步",
  "step3": "第三步",
  "submitDeposit": "提交充值",
  "submitWithdrawal": "提交提现",
  "swapToExaltText": "将您的 BNB 或 USDT 兑换为 EXALT。",
  "totalAssets": "总资产",
  "totalPortfolioValue": "资产组合总价值",
  "transactionHashReference": "交易哈希/参考编号",
  "transfer": "划转",
  "usdtWallet": "USDT 钱包",
  "useBscReminder": "请务必使用 BNB 智能链（BEP-20）网络。",
  "verifyContractReminder": "交易前请务必核实官方合约地址。",
  "waitingAdminApproval": "等待管理员审批。",
  "wallet": "钱包",
  "walletAddress": "钱包地址",
  "walletBankIbanPlaceholder": "钱包地址 / JazzCash / Easypaisa / 银行账户 / IBAN",
  "walletNotConnected": "钱包未连接",
  "walletStatus": "钱包状态",
  "walletsSubtitle": "管理加密货币钱包、充值、提现及付款请求。",
  "walletsTitle": "钱包",
  "withdraw": "提现",
  "withdrawRequiredFields": "金额、账户名称及钱包/账户号码为必填项。",
  "withdrawalFailed": "提现失败。",
  "withdrawalRequest": "提现请求",
  "withdrawalSubmittedSuccessfully": "提现请求提交成功。",
  "yourName": "您的姓名"
}